export default "__VITE_ASSET__Cl3MO17E__"